import { render, staticRenderFns } from "./ReadEmailModal.vue?vue&type=template&id=122a7daa&"
import script from "./ReadEmailModal.vue?vue&type=script&lang=js&"
export * from "./ReadEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./ReadEmailModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {IconClose: require('/lasso/components/icons/IconClose.vue').default,Template: require('/lasso/components/templates/Template.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('122a7daa')) {
      api.createRecord('122a7daa', component.options)
    } else {
      api.reload('122a7daa', component.options)
    }
    module.hot.accept("./ReadEmailModal.vue?vue&type=template&id=122a7daa&", function () {
      api.rerender('122a7daa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/inbox/ReadEmailModal.vue"
export default component.exports